import React, { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { canSeeVoti, login_url } from '../globals';
import { ErrorBlockGeneric } from '../components';
import { useCategoriaEvento, useLogin, useCategoria, usePartecipante, useThread } from '../reducers';
import TabellaProblemi from '../components/TabellaProblemi';
import FiltriProblemi from '../components/FiltriProblemi';
import './ListaThreadProblemi.scss';

export { empty_initial_values, filtra } from '../utils/problemFilters';
export type { FormValues, SortFunc } from '../utils/problemFilters';

const ListaThreadProblemi = (props: {}) => {
  const location = useLocation();
  const params = useParams<{ pk: string }>();

  const login = useLogin();
  const categorie = useCategoria(props);
  const categorieevento = useCategoriaEvento(props);
  const thread = useThread(props);
  usePartecipante(props);

  useEffect(() => {
    if (!login.logged_in) login_url();
  }, [login.logged_in]);


  let immutable: 'categorie' | 'categorieevento' | undefined;
  let error = undefined;
  let extra_text = "";

  if (location.pathname.match(/thread\/problema\/categoria\//g)) {
    immutable = "categorie";
    const this_categoria = categorie.find(item => item.id == parseInt(params.pk as string));
    if (!this_categoria) {
      error = "Errore nella scelta della categoria, se hai seguito un link per arrivare qui segnalalo a un amministratore"
    } else {
      extra_text = ` di ${this_categoria.nome}`
    }
  }
  if (location.pathname.match(/thread\/problema\/categoria-evento/g)) {
    immutable = "categorieevento";
    const this_categoriaevento = categorieevento.find(item => item.id == parseInt(params.pk as string));
    if (!this_categoriaevento) {
      error = "Errore nella scelta della categoria Evento, se hai seguito un link per arrivare qui segnalalo a un amministratore"
    } else {
      extra_text = ` proposte per ${this_categoriaevento.nome}`
    }
  }

  const scope = location.pathname.includes('/miei') ? 'miei' : location.pathname.includes('/assegnati') ? 'assegnati' : 'tutti';
  const scopeLabel = scope === 'miei' ? 'Proposti da me' : scope === 'assegnati' ? 'Assegnati a me' : 'Tutti i problemi';

  useEffect(() => {
    document.title = `${scopeLabel}${extra_text} - Owlitrack`;
  }, [scopeLabel, extra_text]);

  const lockedFilter = immutable ? {
    field: immutable,
    id: Number(params.pk),
    label: immutable === 'categorie'
      ? categorie.find(item => item.id === Number(params.pk))?.nome || `Categoria ${params.pk}`
      : categorieevento.find(item => item.id === Number(params.pk))?.nome || `Categoria evento ${params.pk}`,
  } : undefined;

  return (
    <div className="container problem-list">
      <div className="d-flex flex-wrap align-items-start justify-content-between mb-3">
        <div>
          <h1 className="mb-1">Problemi</h1>
          <p className="text-muted mb-2">{scopeLabel}{extra_text}</p>
        </div>
        <Link to="/thread/problema/new/" className="btn btn-primary mt-1">
          <i className="fa fa-plus mr-2" aria-hidden="true" />Nuovo problema
        </Link>
      </div>
      <nav className="nav nav-pills problem-list-views mb-3" aria-label="Viste problemi">
        {([
          ['tutti', '/thread/problema/', 'Tutti'],
          ['miei', '/thread/problema/miei/', 'Proposti da me'],
          ['assegnati', '/thread/problema/assegnati/', 'Assegnati a me'],
        ] as const).map(([view, path, label]) => <Link key={view} to={path}
          className={`nav-link${scope === view ? ' active' : ''}`} aria-current={scope === view ? 'page' : undefined}>{label}</Link>)}
      </nav>
      {error && <ErrorBlockGeneric error={error} />}
      <FiltriProblemi threads={thread} lockedFilter={lockedFilter}>
        {filtered => <TabellaProblemi threads={filtered} currentParticipantId={login.user.id}
          ratings={canSeeVoti(login.user.permessi) ? 'spoiler' : 'hidden'} />}
      </FiltriProblemi>
    </div>
  );
}

export default ListaThreadProblemi;
